import { useState } from "react";
import { default as signUpService } from "../services/signUp"
import { SignUpDataAPI, SignUpResponseError, State } from "../types/signup";
import { AxiosError } from "axios";


export const useSignUp = () => {

  const [state, setState] = useState<State>("idle");
  const [errors, setErrors] = useState<SignUpResponseError["errors"]>();

  const removeError = (field: keyof SignUpResponseError["errors"]) => {
    setErrors({...errors, [field]: undefined});
  }

  const confirmForm = (data: SignUpDataAPI) => {
    setState("submitting");
    signUpService.confirmSignUp(data)
    .then((res) => {
      setState("submitted");
    })
    .catch((err: AxiosError<SignUpResponseError>) => {
      setState("idle");
      setErrors(err.response?.data.errors);
    })
  }

  return {
    errors,
    state,
    confirmForm,
    removeError
  }
}